

import { config } from "../../../../../../utils/config";
import { Page } from "../../../../../../enums/page";

import { currencyFormatter } from "../../../../../../utils/currency";
import { ReactComponent as PromoCoupon } from '../../../../../../assets/icons/promo-coupon.svg';

import i18n from '../../../../../../utils/translations/i18n';

const getShippingCharges = (model) => {
    if (model.totalDeliveryChargeWithGlobalDiscount) {
        let strikeOutFree: any = '';
        if (model.totalDeliveryChargeWithGlobalDiscount === 'Free') {
            strikeOutFree = <div>
                <span className="free-shipping">{i18n.t('order_details.free')}</span></div>;
        } else if (model.totalDeliveryChargeWithGlobalDiscount > 0) {
            strikeOutFree = <div><span className="strike-out">{currencyFormatter(model.totalDeliveryCharge, model.fractionDigits)}</span>&nbsp;{currencyFormatter(model.totalDeliveryChargeWithGlobalDiscount, model.fractionDigits)}</div>;
        }
        return <span className="green-text">
            {strikeOutFree}
        </span>;
    }

    return currencyFormatter(model.totalDeliveryCharge, model.fractionDigits);
}

const renderFreeShipping = () => (
    <div>
      <span className="free-shipping">{i18n.t('order_details.free')}</span>
    </div>
  );

const fetchShippingDiscounts = ({
    totalDeliveryCharge,
    totalDeliveryChargeWithGlobalDiscount,
    totalDeliveryChargeWithCouponDiscount,
    totalDeliveryChargeWithAllDiscount,
    shippingCustomItem,
    shippingType,
    fractionDigits
  },globalThresholdMet,isGlobalCartDiscountFree,globalDiscountShippingType,coupon,isThresholdMet,isShippingDisc,isShippingCouponFree) => {
    if((shippingType && (shippingType === globalDiscountShippingType)) && globalThresholdMet && isGlobalCartDiscountFree && !shippingCustomItem){
        return renderFreeShipping();
    }
    const isShippingCouponDiscountFree = ((!shippingCustomItem && coupon?.thresholdValue && isThresholdMet && isShippingDisc && isShippingCouponFree) || (!shippingCustomItem && !coupon?.thresholdValue && isShippingDisc && isShippingCouponFree)) ?? false;

    if(isShippingCouponDiscountFree){
        return renderFreeShipping();
    }

    if(!shippingCustomItem){
        return i18n.t('order_summary.tbd')
    }
    
    if (totalDeliveryChargeWithGlobalDiscount === 'Free' || 
        totalDeliveryChargeWithCouponDiscount === 'Free' || 
        totalDeliveryChargeWithAllDiscount === 0) {
            return renderFreeShipping();
    }
  
    const hasDiscount = totalDeliveryChargeWithGlobalDiscount > 0 || totalDeliveryChargeWithCouponDiscount > 0;
  
    if (hasDiscount) {
      return (
        <div>
          <span className="strike-out">{currencyFormatter(totalDeliveryCharge, fractionDigits)}</span>
          &nbsp;{currencyFormatter(totalDeliveryChargeWithAllDiscount, fractionDigits)}
        </div>
      );
    }
  
    return totalDeliveryCharge
      ? currencyFormatter(totalDeliveryCharge, fractionDigits)
      : i18n.t('order_summary.tbd');
  };



const getDeliveryDetailsWithVATSection = (model, currentPage, hideShippingLineitem, toggleShippingChargesDetail, showDeliveryWithoutTax, shippingType) => {
    let mowShowShippingVat = false;
    if (config('isNASite') === false && currentPage !== Page.CHECKOUTSHIPPING) {
        mowShowShippingVat = true;
    }
    return <div>
        {<div className={`summary-order__item ${hideShippingLineitem}`} id="delivery-incl-vat"><span>
            {mowShowShippingVat ? `${i18n.t('order_summary.standard_delivery_vat')}` : `${i18n.t('order_summary.standard_delivery')}`}&nbsp;
            {mowShowShippingVat && <span className={`icon ${showDeliveryWithoutTax ? 'icon-arrow-up' : 'icon-arrow-down'}`} onClick={toggleShippingChargesDetail}></span>}
            {<span className="del-txt" id={currentPage === Page.CHECKOUTPAYMENT && config('isNASite') ? 'default-na-ship-method' : ''}>{config('isNASite') && (currentPage === Page.CHECKOUTPAYMENT || currentPage === Page.ORDERCONFIRMATION) ? shippingType : i18n.t('checout_payment.standard_delivery')}</span>}
        </span>
            <span>
                <span className="shipping-charges">
                    {config('isNASite') ? getShippingCharges(model) : currencyFormatter(model.totalDeliveryChargeInclVat, model.fractionDigits)}
                </span>
            </span>
        </div>}
    </div>
}

const getOrderSummaryTaxSection = (model, currentPage) => {
    let showTaxSection = false;
    if (config('isNASite')) {
        if ((currentPage === Page.CHECKOUTPAYMENT || currentPage === Page.ORDERCONFIRMATION)) {
            showTaxSection = true;
        }
    } else {
        if (currentPage === Page.CHECKOUTSHIPPING) {
            showTaxSection = true;
        }
    }
    return <div>
        {showTaxSection && <div className="summary-order__item gatax">{config('isNASite') ? <span id="naVat">{i18n.t('order_summary.estimatedSalesTax')}
            &nbsp;
            <span className="tooltip-container">
                <div className="tooltip info-icon" title="Exact sales tax included in your shipment confirmation email."></div>
            </span>
        </span> : <span id="mowVat">{i18n.t('order_summary.vat')}</span>}
            <span id="total-VAT" className='totalVAT'>{currentPage === Page.CHECKOUTSHIPPING ? currencyFormatter(model.VATWithoutShipping, model.fractionDigits) : currencyFormatter(model.totalVAT, model.fractionDigits)}</span></div>}
    </div>
}

const getShippingDiscountSection = (model, hideShippingLineitem, showDeliveryWithoutTax) => {
    return <div> {(config('isNASite') || showDeliveryWithoutTax) && <div id="shippingDiscount-section" className={`summary-order__item shipping-discount ${config('isNASite') ? 'na-shipping-discount' : ''} ${hideShippingLineitem}`} >
        <span>{i18n.t('shopping_cart_details.shipping_discount')} </span>
        <span id="shipping-discount">- {currencyFormatter(model.shippingDiscount, model.fractionDigits)}</span>
    </div>} </div>
}

const getDeliveryDetailsWithoutVATSection = (model, hideShippingLineitem, showDeliveryWithoutTax) => {
    return <div className={`summary-order__item gashipping ${hideShippingLineitem} ${showDeliveryWithoutTax ? '' : 'shipping-drop-down-items'}`} id="delivery">
        <span>{i18n.t('order_summary.standard_delivery_excl_vat')}</span>
        <span className="shipping-charges">
            {getShippingCharges(model)}
        </span>
    </div>
}

const getUSBTaxSection = (model) => {
    return <div><div className="summary-order__item gausbtax">
        <span>{i18n.t('shopping_cart_details.usbTax')}</span><span id="total-USBTAX">{currencyFormatter(model.USBTax, model.fractionDigits)}</span>
    </div></div>
}

const getCartTotalSection = (model, currentPage) => {
    return <div><div className="summary-order__item garevenue">
        {currentPage !== Page.CHECKOUTSHIPPING ? <span className="kilo os-total-amt checkout-hide">{i18n.t('order_summary.total')}</span> :
            <span className="kilo os-total-amt checkout-hide">{i18n.t('shopping_cart_details.subTotalInclVat')}</span>}
        <span className="giga brand bold"><span id="total_price">{currentPage === Page.CHECKOUTSHIPPING ? currencyFormatter(model.cartTotal, model.fractionDigits) : currencyFormatter(model.cartTotalWithShipping, model.fractionDigits)}</span>
        </span>
    </div></div>
}

const getYouSavedSectionWithOtherCharges = (model, currentPage) => {
    let totalCartSavingClass = '';
    let totalSavings: any = '';
    if (!model.totalDiscountWithoutCurrency) {
        totalCartSavingClass = 'hidden';
    }

    if (currentPage === Page.CHECKOUTSHIPPING && model.isTotalSavingWithoutShippingDiscountAvailable) {
        totalSavings = currencyFormatter(model.totalSavingWithoutShippingDiscount, model.fractionDigits);
        totalCartSavingClass = ''
    } else if (currentPage !== Page.CHECKOUTSHIPPING && model.isCartTotalSavingAvailable) {
        totalSavings = currencyFormatter(model.cartTotalSaving, model.fractionDigits);
        totalCartSavingClass = ''
    } else {
        totalCartSavingClass = 'hidden';
        totalSavings = 0;
    }

    return <div id="youSavedSection" className={`summary-order__item you-saved-sec ${totalCartSavingClass}`}>
        <span></span>
        <span className="you-saved__amount">
            <span>{i18n.t('shopping_cart_details.you_saved').replace('[X]', totalSavings)}!</span>
        </span>
    </div>
}

const getShippingSectionForShippingPage = (model, displayShippingMethods, displayShippingDiscount) => {
    return <div>
        <div className="summary-order__item">
            <span id="cart-shipping-label">{i18n.t('shopping_cart_details.shippingInfoLabel')}
            </span>
            <span className="cart-shipping">{displayShippingMethods ? currencyFormatter(model.totalDeliveryCharge, model.fractionDigits) : <div>&#45;&#45;</div>}</span>
        </div>
        {model.isShippingDiscountAvailable && displayShippingDiscount && <div id="ship-page-discount" className="summary-order__item shipping-discount na-shipping-discount">
            <span>{i18n.t('shopping_cart_details.shipping_discount')} </span>
            <span id="shipping-discount">- {currencyFormatter(model.shippingDiscount, model.fractionDigits)}</span>
        </div>}
    </div>
}


export const getOrderSummaryWithOtherCharges = (model, currentPage, toggleShippingChargesDetail, showDeliveryWithoutTax, shippingType, displayShippingMethods, displayShippingDiscount) => {
    const hideShippingLineitem = currentPage !== Page.CHECKOUTSHIPPING ? '' : 'hidden';
    return <div>
        {config('isNASite') === false && currentPage === Page.CHECKOUTSHIPPING && getShippingSectionForShippingPage(model, displayShippingMethods, displayShippingDiscount)}
        {getDeliveryDetailsWithVATSection(model, currentPage, hideShippingLineitem, toggleShippingChargesDetail, showDeliveryWithoutTax, shippingType)}
        {getDeliveryDetailsWithoutVATSection(model, hideShippingLineitem, showDeliveryWithoutTax)}
        {model.isShippingDiscountAvailable && getShippingDiscountSection(model, hideShippingLineitem, showDeliveryWithoutTax)}
        {getOrderSummaryTaxSection(model, currentPage)}
        {model.USBTax ? getUSBTaxSection(model) : ''}
        {getCartTotalSection(model, currentPage)}
        {config('isNASite') === true && getTotalSavings(model, currentPage)}
        {config('isNASite') === false && getYouSavedSectionWithOtherCharges(model, currentPage)}
    </div>
}


export const getCartSubtotal = (model, pageType, otherCharges) => {
    let mowShowShippingVat = false;
    let cartSubtotal = model.cartSubtotal;
    if (config('isNASite') === false && pageType !== Page.CHECKOUTSHIPPING) {
        mowShowShippingVat = true;
        cartSubtotal = model.cartSubtotalInclVat;
    }

    return (
        <div className={`summary-order__item ${otherCharges ? 'naChargesNotApplicable' : 'naChargesApplicable'}`} id="sub-total">
            <span>
                {mowShowShippingVat ? i18n.t('header.total') : i18n.t('order_summary.subtotal')}
            </span>
            <span id="cart-subtotal" >
                {currencyFormatter(cartSubtotal, model.fractionDigits)}
            </span>
        </div>
    )
}

export const getTaxShippingAndSaving = (cart, currentPage,globalThresholdMet,isGlobalCartDiscountFree,globalDiscountShippingType,coupon,isThresholdMet,isShippingDisc,isShippingCouponFree) => {
    if (!config('isNASite')) return null;

    const taxWithoutShipping = (cart?.shippingCustomItem && cart?.VATWithoutShipping != null && cart?.VATWithoutShipping != undefined) 
        ? currencyFormatter(cart.VATWithoutShipping, cart.fractionDigits) 
        : i18n.t('order_summary.tbd');

    return (
        <>
            <div className={`${currentPage === Page.SHOPPINGBAG ? 'shoppingBag-shipping':'checkoutPage-shipping'}`}>
                <span>{i18n.t('header.shipping')}</span>
                <span>{fetchShippingDiscounts(cart,globalThresholdMet,isGlobalCartDiscountFree,globalDiscountShippingType,coupon,isThresholdMet,isShippingDisc,isShippingCouponFree)}</span>
            </div>
            <div className={`${currentPage === Page.SHOPPINGBAG ? 'shoppingBag-tax':'checkoutPage-tax'}`}>
                <span>{i18n.t('order_summary.vat')}</span>
                <span>{taxWithoutShipping}</span>
            </div>
            {getTotalSavings(cart, currentPage)}
        </>
    );
};


export const getTotalSavings = (cart,currentPage) => {
    let totalCartSavingClass = '';
    let totalSavings: any = '';
    let isTextBlack = '';
    if (!cart.totalDiscountWithoutCurrency) {
        totalCartSavingClass = 'hidden';
    }

    if ((currentPage === Page.SHOPPINGBAG || currentPage === Page.CHECKOUTSHIPPING) && cart.isTotalSavingWithoutShippingDiscountAvailable) {
        totalSavings = currencyFormatter(cart.totalSavingWithoutShippingDiscount, cart.fractionDigits);
        totalCartSavingClass = 'cart-shipping-savings'
    } else if ((currentPage === Page.CHECKOUTPAYMENT || currentPage === Page.ORDERCONFIRMATION)  && cart.isCartTotalSavingAvailable) {
        totalSavings = currencyFormatter(cart.cartTotalSaving, cart.fractionDigits);
        totalCartSavingClass = 'order-summary-payment-confirmation'
        isTextBlack = 'text-black';
    } else {
        totalCartSavingClass = 'hidden';
        totalSavings = 0;
    }
    return (
        <div className={`totalSavings ${totalCartSavingClass}`}>
            <span id="total-cartSaving">{currentPage === Page.ORDERCONFIRMATION?i18n.t('order_summary.you_saved'):i18n.t('order_summary.you_are_saving')}&nbsp;{totalSavings}!</span>
        </div> )
}


